import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import RootComponent from './Render/RootComponent';

// This is a hack to get the i18n instance into the React context
// so that it can be used in the RootComponent.
import '@higherlogic/i18n/src/i18nReactInit';

export const renderApp = (rootId: string, globalData: GlobalData) => {
    const rootEle = document.getElementById(rootId);
    if (rootEle) {
        createRoot(rootEle).render(
            <Suspense fallback={<div>Loading translations...</div>}>
                <RootComponent globalData={globalData} />
            </Suspense>
        );
    } else {
        console.error('react root element not found');
    }
};
